import { lrSearchColumns } from '../../helper/constantHelper'
import { paymentModesWithAll } from '../common/paymentsMode'

const sl = (translations) => translations?.searchLrPopup || {}

export const getSearchByOptions = (translations) => {
  const t = sl(translations)
  return [
    { id: 1, name: t.lrNumber || 'LR Number' },
    { id: 2, name: t.challanNumber || 'Challan Number' },
    { id: 3, name: t.manualLrNumber || 'Manual LR Number' },
    { id: 4, name: t.senderMobileNumber || 'Sender Mobile Number' },
    { id: 5, name: t.receiverMobileNumber || 'Receiver Mobile Number' },
    { id: 8, name: t.gstInvoiceNumber || 'GST Invoice Number' },
  ]
}

export const getSearchByLabel = (id, translations) =>
  getSearchByOptions(translations).find((o) => o.id === id)?.name

const getPaymentLabel = (typeId, translations, UseToPayAsCOD) => {
  const t = sl(translations)
  if (UseToPayAsCOD === 1) {
    if (typeId === 2) return t.cod || 'COD'
    if (typeId === 7) return t.codManual || 'COD(MANUAL)'
    if (typeId === 9) return t.codDddv || 'COD(DDDV)'
    if (typeId === 4) return null
  }
  const labels = {
    0: t.all || 'All',
    1: t.paid || 'Paid',
    2: t.toPay || 'To Pay',
    3: t.foc || 'FOC',
    4: t.cod || 'COD',
    5: t.onAccount || 'On Account',
    6: t.paidManual || 'Paid (Manual)',
    7: t.toPayManual || 'To Pay (Manual)',
    8: t.self || 'Self',
    9: t.toPayDddv || 'To Pay DDDV',
    10: t.onAccountManual || 'On Account (Manual)',
  }
  return labels[typeId]
}

export const getPaymentModesForSearch = (translations, UseToPayAsCOD = 0) =>
  (paymentModesWithAll || [])
    .map((item) => {
      const name = getPaymentLabel(item.typeId, translations, UseToPayAsCOD)
      if (name == null) return null
      return { ...item, name }
    })
    .filter(Boolean)

export const getPaymentTypeLegend = (translations) => {
  const t = sl(translations)
  return [
    { color: '#d1f5d3', value: t.legendPaid || 'Paid' },
    { color: '#e2e3f3', value: t.legendOnAccount || 'ON Acount' },
    { color: '#ffe0bd', value: t.legendToPay || 'To Pay' },
    { color: '#c3f8ff', value: t.legendSelf || 'Self' },
    { color: '#ffd8e5', value: t.legendCod || 'COD' },
    { color: '#BDE1E1', value: t.legendFoc || 'FOC' },
    { color: '#fffdaf', value: t.legendToPayDddv || 'ToPay(DDDV)' },
  ]
}

export const getLrSearchColumns = (translations) => {
  const t = sl(translations)
  const headerMap = {
    BookingID: t.select || 'Select',
    LRNo: t.lrNo || 'LR No.',
    FormattedLRNO: t.lrNoFormat || 'LR No. Format',
    ManualLRNo: t.lrNoManual || 'LR No. Manual',
    BookingDateTime: t.bookingDateAndTime || 'Booking Date & Time',
    Status: t.lrNoStatus || 'LR No. Status',
    VoucherNo: t.challanNo || 'Challan No.',
    PaymentType: t.paymentType || 'Payment Type',
    Sender: t.senderName || 'Sender Name',
    SenderMobileNo: t.senderNumber || 'Sender Number',
    RecName: t.receiverName || 'Receiver Name',
    RecMobileNo: t.receiverNumber || 'Receiver Number',
    BookingBranchName: t.sourceBranch || 'Source Branch',
    DestinationBranchName: t.destinationBranch || 'Destination Branch',
  }
  return lrSearchColumns.map((col) => ({
    ...col,
    header: headerMap[col.id] || col.header,
  }))
}

export const getTranslatedColumns = (columns, translations) => {
  const defaults = getLrSearchColumns(translations)
  return columns.map((col) => {
    const def = defaults.find((d) => d.id === col.id)
    return def ? { ...col, header: def.header } : col
  })
}
